import Script from 'next/script';

const BookingStartScript = () => {
  return process.env.NEXT_PUBLIC_ENGAGE_BOT_EMAIL_APP_ID &&
    process.env.NEXT_PUBLIC_ENGAGE_BOT_TELEPHONE_APP_ID &&
    process.env.NEXT_PUBLIC_ENGAGE_BOT_SDK_WEB_FORM_DOING_SCRIPT ? (
    <>
      <Script id="booking-start" strategy="afterInteractive" type="text/javascript">
        {`
        window.ebSettings_2 = [{
            eb_appId: '${process.env.NEXT_PUBLIC_ENGAGE_BOT_EMAIL_APP_ID}', 
            eb_email: 'input[name="email"]',
        }, {
            eb_appId: '${process.env.NEXT_PUBLIC_ENGAGE_BOT_TELEPHONE_APP_ID}',
            eb_tel: 'input[name="phone"]',
        }];
        `}
      </Script>
      <Script
        id="booking-start-script"
        strategy="afterInteractive"
        src={process.env.NEXT_PUBLIC_ENGAGE_BOT_SDK_WEB_FORM_DOING_SCRIPT}
      />
    </>
  ) : null;
};

export default BookingStartScript;
